import QuestionLayout from "./QuestionLayout";
import StandaloneRhythmGlyph, {
  isStandaloneRhythmSymbol,
} from "./staff/StandaloneRhythmGlyph";

function normalizeBeatInput(input) {
  if (!input) return "";

  return input.trim();
}

export default function BeatValueWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback,
}) {
  function updateItem(id, nextValue) {
    onChange({
      ...value,
      [id]: normalizeBeatInput(nextValue),
    });
  }

  function itemFeedback(id) {
    return feedback?.parts?.[id] ?? null;
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${config.itemsPerRow || 3}, 1fr)`,
          columnGap: 28,
          rowGap: 22,
          alignItems: "center",
        }}
      >
        {(config.items || []).map((item) => {
          const fb = itemFeedback(item.id);

          return (
            <div
              key={item.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                whiteSpace: "nowrap",
              }}
            >
              {isStandaloneRhythmSymbol(item.editorSymbol) ? (
                <StandaloneRhythmGlyph
                  symbol={item.editorSymbol}
                  label={item.alt || item.editorSymbol.replaceAll("_", " ")}
                  width={item.width || config.imageWidth || 70}
                  height={item.height || config.imageHeight}
                />
              ) : (
                <img
                  src={item.image}
                  alt={item.alt || ""}
                  style={{
                    width: item.width || config.imageWidth || 70,
                    height: item.height || config.imageHeight || 45,
                    objectFit: "contain",
                  }}
                />
              )}

              <span style={{ fontSize: 18 }}>=</span>

              <input
                type="text"
                inputMode="decimal"
                value={value[item.id] || ""}
                disabled={mode !== "edit"}
                onChange={(e) => updateItem(item.id, e.target.value)}
                style={{
                  width: 48,
                  fontSize: 16,
                  textAlign: "center",
                  padding: "7px 8px",
                  borderRadius: 6,
                  border:
                    mode === "review"
                      ? fb?.correct
                        ? "2px solid #2e7d32"
                        : "2px solid #c62828"
                      : "1px solid #aaa",
                }}
              />

              <span style={{ fontSize: 16 }}>beat(s)</span>
            </div>
          );
        })}
      </div>
    </QuestionLayout>
  );
}
